<script setup>
import { onMounted, ref } from 'vue'
import { useWebSiteStore } from '@/stores/website.store'
import { useNotify } from '@/composables/notify'
import { useRouter } from 'vue-router'
import i18n from '@/plugins/i18n'

const router = useRouter()

const loading = ref(true)

const websiteStore = useWebSiteStore()
const t = i18n.global.t
const {notifyError, notifySuccess} = useNotify()

onMounted(async() => {
  try {
    loading.value = true
    await websiteStore.validateEmailAsync(router.currentRoute.value.query.token, router.currentRoute.value.query.user_id)
    notifySuccess(t('user.notifications.emailValidated'))
    router.push({ name: 'login' })
  } catch (error) {
    notifyError(t('error.invalidConfirmationToken'))
    router.push({ name: 'login' })
  } finally {
    loading.value = false
  }
})

</script>

<template>
  <q-layout view="lHh Lpr lFf">
    <q-page-container>
      <q-page class="flex flex-center bg-gradient window-height">
        <q-spinner-dots
          v-if="loading"
          size="50px"
          color="white"
        />
      </q-page>
    </q-page-container>
  </q-layout>
</template>

<style lang="scss" scoped>
@import '@/styles/auth-forms.scss';
</style>

